/** Display formatters shared across the app. */

const numberFmt = new Intl.NumberFormat('en-IN');

/** 12500 -> "12,500" (Indian grouping) */
export function formatNumber(value) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '—';
  return numberFmt.format(Number(value));
}

/** ISO date string -> "12 Mar 2026" */
export function formatDate(value) {
  if (!value) return '—';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

/** ISO date string -> "12 Mar 2026, 4:30 pm" */
export function formatDateTime(value) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return `${formatDate(date)}, ${date.toLocaleTimeString('en-IN', {
    hour: 'numeric',
    minute: '2-digit',
  })}`;
}

/** Today as `YYYY-MM-DD`, used as the min value for date inputs. */
export function todayISO() {
  const now = new Date();
  const offset = now.getTimezoneOffset() * 60000;
  return new Date(now.getTime() - offset).toISOString().slice(0, 10);
}

/** Quantity + unit -> "2,400 kg" */
export function formatQuantity(quantity, unit) {
  if (!quantity) return '—';
  return `${formatNumber(quantity)} ${unit || ''}`.trim();
}

/** Sequential-looking demo request id, e.g. "EW-2026-4821". */
export function generateRequestId() {
  const year = new Date().getFullYear();
  const suffix = Math.floor(1000 + Math.random() * 9000);
  return `EW-${year}-${suffix}`;
}

/** "Acme Industries Pvt Ltd" -> "AI" */
export function initials(name = '') {
  return name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join('');
}
